import localStorageService from "../../../services/localStorageService";
import {
  LOCAL_STORAGE_ACCESS_TOKEN,
  LOCAL_STORAGE_REFRESH_TOKEN,
} from "../../../utils/constants";
import { fetchUserInfo } from "../user/asyncThunks";
import {
  login,
  logout,
  signup,
  forgotPassword,
  forgotPasswordSendCode,
} from "./asyncThunks";

export const loginBuilder = (builder) => {
  builder.addCase(login.pending, (state) => {
    state.login.attempt = true;
    state.login.success = false;
    state.login.error = null;
  });
  builder.addCase(login.fulfilled, (state, action) => {
    const { accessToken, refreshToken } = action.payload;
    state.login.attempt = false;
    state.login.success = true;
    state.login.error = null;
    state.loggedIn = true;
    localStorageService.setItem(LOCAL_STORAGE_ACCESS_TOKEN, accessToken);
    localStorageService.setItem(LOCAL_STORAGE_REFRESH_TOKEN, refreshToken);
  });
  builder.addCase(login.rejected, (state, action) => {
    state.login.attempt = false;
    state.login.success = false;
    state.login.error = action.payload;
  });
};

export const fetchUserInfoBuilder = (builder) => {
  builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
    state.loggedIn = true;
  });
  builder.addCase(fetchUserInfo.rejected, (state, action) => {
    state.loggedIn = false;
  });
};

export const logoutBuilder = (builder) => {
  builder.addCase(logout.fulfilled, (state) => {
    localStorageService.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorageService.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    state.loggedIn = false;
  });
  builder.addCase(logout.rejected, (state) => {
    localStorageService.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorageService.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    state.loggedIn = false;
  });
};

export const signupBuilder = (builder) => {
  builder.addCase(signup.pending, (state) => {
    state.signup.attempt = true;
    state.signup.success = false;
    state.signup.error = null;
  });
  builder.addCase(signup.fulfilled, (state, action) => {
    state.signup.attempt = false;
    state.signup.success = true;
    state.signup.error = null;
  });
  builder.addCase(signup.rejected, (state, action) => {
    state.signup.attempt = false;
    state.signup.success = false;
    state.signup.error = action.payload;
  });
};

export const forgotPasswordBuilder = (builder) => {
  builder.addCase(forgotPassword.pending, (state) => {
    state.forgotPassword.attempt = true;
    state.forgotPassword.success = false;
    state.forgotPassword.error = null;
  });
  builder.addCase(forgotPassword.fulfilled, (state, action) => {
    state.forgotPassword.attempt = false;
    state.forgotPassword.success = true;
    state.forgotPassword.error = null;
  });
  builder.addCase(forgotPassword.rejected, (state, action) => {
    state.forgotPassword.attempt = false;
    state.forgotPassword.success = false;
    state.forgotPassword.error = action.payload;
  });
};

export const forgotPasswordSendCodeBuilder = (builder) => {
  builder.addCase(forgotPasswordSendCode.pending, (state) => {
    state.forgotPasswordSendCode.attempt = true;
    state.forgotPasswordSendCode.success = false;
    state.forgotPasswordSendCode.error = null;
  });
  builder.addCase(forgotPasswordSendCode.fulfilled, (state, action) => {
    state.forgotPasswordSendCode.attempt = false;
    state.forgotPasswordSendCode.success = true;
    state.forgotPasswordSendCode.error = null;
  });
  builder.addCase(forgotPasswordSendCode.rejected, (state, action) => {
    state.forgotPasswordSendCode.attempt = false;
    state.forgotPasswordSendCode.success = false;
    state.forgotPasswordSendCode.error = action.payload;
  });
};
